import { getAuthUser } from "../helpers/auth";

const useRoles = (_permissions = []) => {
    const user = getAuthUser();
    const roles = user?.roles?.flatMap((role: any) => role.name) || [];
    return {
        permissions: roles,
        hasRole: (role: any) => roles?.includes(role)
    };

};

export default useRoles;
